import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e49abe3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-timeline p-component p-timeline-left p-timeline-horizontal" }
const _hoisted_2 = { class: "p-timeline-event-separator" }
const _hoisted_3 = {
  key: 0,
  class: "pi pi-check"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "p-timeline-event-connector"
}
const _hoisted_6 = { class: "step-name" }

import { useRouter } from "vue-router";

/**
 * ルーティング定数
 * ルートパスの定義に使用
 */
import RouterConstants from "../constants/router.constants";

/**
 * ルートパスとステップ名のマッピング
 * 各ルートパスに対応するステップ名を定義
 * @type {Record<string, string>}
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingStepsHeader',
  setup(__props) {

/**
 * 予約ステップヘッダーコンポーネント
 * 予約フローの進行状況を表示するタイムラインコンポーネント
 * 現在のステップ、完了したステップ、未完了のステップを視覚的に表示
 */

/**
 * Vue Router
 * 現在のルート情報の取得に使用
 */
const stepsMapping: Record<string, string> = {
  [RouterConstants.BOOKING_ROUTER_PATH]: "予約内容",
  [RouterConstants.BOOKING_MENU_CATEGORY_ROUTER_PATH]: "予約内容",
  [RouterConstants.BOOKING_MENU_ROUTER_PATH]: "予約内容",
  [RouterConstants.BOOKING_OPTION_ROUTER_PATH]: "予約内容",
  [RouterConstants.BOOKING_PREVIEW_ROUTER_PATH]: "予約内容",
  [RouterConstants.BOOKING_CALENDAR_ROUTER_PATH]: "予約日時",
  [RouterConstants.PERSONAL_INFO_ROUTER_PATH]: "個人情報",
  [RouterConstants.CONTENT_CONFIRMATION_ROUTER_PATH]: "内容確認",
  [RouterConstants.OTP_FORM_PATH]: "内容確認",
};

/**
 * Vue Routerインスタンス
 */
const router = useRouter();

/**
 * 指定されたステップが現在のステップかどうかを判定
 * @param {string} stepName - 判定対象のステップ名
 * @returns {boolean} 現在のステップの場合はtrue
 */
const isCurrentStep = (stepName: string): boolean => {
  return stepsMapping[router.currentRoute.value.path] == stepName;
};

/**
 * ステップのマーカーの非アクティブ状態のクラスを取得
 * @param {string} stepName - ステップ名
 * @returns {string} 非アクティブ状態の場合は"inactive"、それ以外は空文字
 */
const inactiveClass = (stepName: string): string => {
  return isCurrentStep(stepName) ? "" : "inactive";
};

/**
 * ステップのコンテンツの非アクティブ状態のクラスを取得
 * @param {string} stepName - ステップ名
 * @param {number} index - ステップのインデックス
 * @returns {string} 非アクティブ状態の場合は"inactive"、それ以外は空文字
 */
const inactiveContent = (stepName: string, index: number): string => {
  return isCurrentStep(stepName) || steps().indexOf(stepsMapping[router.currentRoute.value.path]) > index
    ? ""
    : "inactive";
};

/**
 * 指定されたステップが完了しているかどうかを判定
 * @param {string} stepName - ステップ名
 * @param {number} index - ステップのインデックス
 * @returns {boolean} 完了している場合はtrue
 */
const completedStep = (stepName: string, index: number): boolean => {
  const stepNames = new Set(Object.values(stepsMapping));
  return [...stepNames].indexOf(stepsMapping[router.currentRoute.value.path]) > index;
};

/**
 * ステップ名の一覧を取得
 * @returns {string[]} 重複を除いたステップ名の配列
 */
const steps = (): string[] => {
  return [...new Set(Object.values(stepsMapping))];
};

/**
 * 最後のステップのクラスを取得
 * @param {number} index - ステップのインデックス
 * @returns {string} 最後のステップの場合は"last-step"、それ以外は空文字
 */
const lastStepClass = (index: number): string => {
  return index != Object.keys(steps()).length - 1 ? "" : "last-step";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(steps(), (stepName, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["p-timeline-event", lastStepClass(index)]),
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["p-timeline-event-marker", inactiveClass(stepName)])
          }, [
            (completedStep(stepName, index))
              ? (_openBlock(), _createElementBlock("i", _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(index + 1), 1))
          ], 2),
          (index != Object.keys(steps()).length - 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["p-timeline-event-content", inactiveContent(stepName, index)])
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(stepName), 1)
        ], 2)
      ], 2))
    }), 128))
  ]))
}
}

})